import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import FetchAllAssetsAsinWiseService from "../../../../../Service/OPSServices/AmazonProductListing/FetchAllAssetsAsinWiseService";
import { connect } from 'react-redux';
import CustomModal from "../../../../Components/Modals/CustomModal";

function ProductListingImages(props) {
  const [mainImages, setMainImages] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryImg, setGalleryImg] = useState()
  const [imagePopUpOPen, setImagePopUpOPen] = useState(false)


  useEffect(() => {
    let data = {
      asin: 'B08P43P2MM'
    }
    FetchAllAssetsAsinWiseService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        setGalleryImg(res.fileList)
      }
    })
  }, [])
  const handleMainImage = (e) => {
    const files = Array.from(e.target.files);
    setMainImages((prev) => [...prev, ...files]);
    e.target.value = "";
  };



  const handleGalleryImages = () => {
    setImagePopUpOPen(true)
  };

  const removeImage = (index) => {
    setGalleryImages(galleryImages.filter((_, i) => i !== index));
  };

  return (
    <>
      <Row>
        <Col md={12} className="mt-2  mb-2 ml-2">
        <div className="d-flex justify-containt-between">
        <h4>Step 5 : Product Images</h4>
          <Button
          className="ml-auto"
            onClick={() => handleGalleryImages()} >
            Products
          </Button>
        </div>
        </Col>

        <Col md={12} className="ml-1 mr-4">
          <Card className="p-4">

            <Row className="mb-4">
              <Col md={4} className="amazon-listing-labels">
                Main Image :
              </Col>

              <Col>
                <img
                  src="https://m.media-amazon.com/images/I/61EmUcXXkHL.jpg"
                  alt="product"
                  style={{ width: "200px", height: "auto" }}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">
                Gallery Images :
              </Col>

              <Col>
                <img
                  src="https://m.media-amazon.com/images/I/71UL0C8LCyL.jpg"
                  alt="product"
                  style={{ width: "200px", height: "auto" }}
                />
              </Col>
            </Row>


          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>
          <button className="btn btn-primary" onClick={props.nextStep}>
            Next →
          </button>
        </Col>
      </Row>
      <CustomModal
        isOpen={imagePopUpOPen}
        toggle={() => setImagePopUpOPen(false)}
        size={"xl"}
        header={''}
        className="curve-popup "
      >
        <Row>
          {galleryImg && galleryImg.map((asset) => (
            <Col sm={4} md={3} >
              <Card>
                <div>
                  <img src={asset.filePath} alt='not found' width={'100%'} height={'100%'} />
                  <p className="text-center mt-2" title={asset.fileName} style={{ fontSize: "13px" }}>
                    {asset.fileName.length > 30
                      ? `${asset.fileName.substring(0, 30)}...`
                      : asset.fileName}
                  </p>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

      </CustomModal>
    </>
  );
}

const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    globalPermissions: state.loggedUser.globalPermissions,
    UserPermission: state.accountOverview.store.StoreUserPermission,
    enableClosedSidebar: state.theme.enableClosedSidebar,
  }
}

export default connect(mapStateToProps)(ProductListingImages);